export enum AdminAddPharmacistFormItemName {
  Email = "email",
  FirstName = "firstName",
  LastName = "lastName",
  Pharmacy = "pharmacy",
}
